// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index.js";
import axios from "axios";
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/resetui.css'
import Qs from "qs";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'babel-polyfill'
import PinchZoom from 'vue-pinch-zoom';
import JSONbig from "json-bigint"
Vue.component('pinch-zoom', PinchZoom);

Vue.use(Vant);
Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false;
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
axios.defaults.transformResponse=[(data) => {
  if (typeof data === 'string') {
    try {
      data = JSONbig.parse(data);
    } catch (e) { /* Ignore */ } // Added this Ignore as it's the same in the Axios
  }
  return data;
}];

// Common loader
Vue.prototype.$NoNetworkErrorMsg = "网络连接失败,稍后再试";

Vue.prototype.$LoadFromDomain = process.env.LOAD_FROM_DOMAIN;

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});


// WEBPACK FOOTER //
// ./src/main.js